import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider';
import { SliderRail, Handle, Track, Tick } from './Components.js';

// CSS
import './VerticalInputSlider.css';

const sliderStyle: React.CSSProperties = {
  position: 'relative',
  height: '500px',
  marginLeft: '45%',
  touchAction: 'none',
};

const domain = [0, 30];
const defaultValues = [0];

export class VerticalInputSlider extends Component {
  state = {
    values: defaultValues.slice(),
    update: defaultValues.slice(),
  };

  onUpdate = (update: ReadonlyArray<number>) => {
    this.setState({ update });
  };

  onChange = (values: ReadonlyArray<number>) => {
    this.setState({ values });
  };

  render() {
    const {
      state: { values, update },
    } = this;

    let changeEvent = this.props.collage.photos.numChosen > 20 ? 'onChange' : 'onUpdate';

    return (
      <div className="VerticalInputSlider">
        <Slider
          vertical={true}
          mode={1}
          step={0.2}
          domain={domain}
          rootStyle={sliderStyle}
          {...{ [changeEvent]: this.props.onChange }}
          values={values}
        >
          <Rail>
            {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
          </Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map((handle) => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    domain={domain}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks right={false}>
            {({ tracks, getTrackProps }) => (
              <div className="slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>
          <Ticks count={5}>
            {({ ticks }) => (
              <div className="slider-ticks">
                {ticks.map((tick) => (
                  <Tick key={tick.id} tick={tick} />
                ))}
              </div>
            )}
          </Ticks>
        </Slider>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  null
)(VerticalInputSlider)
